module.exports = "https://www.gc-qa.gnp.com.mx/2b7d970baf5e498cd97b8b5235021cbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/timer_24px.png
// module id = 8166
// module chunks = 0